import React from 'react'
import { useDispatch } from 'react-redux'
import { Grid } from 'semantic-ui-react'

// @ts-ignore
import FormField, { FormLayout } from 'shared/newFormElements'

import { isRequired } from '../../../helpers'
import { actionTypes } from '../../../constants'
import translate from '../../translate'

const PersonalInformation = ({ fields, selects, noVisibilityFilter, onTranslateAltRequest }) => {
  const dispatch = useDispatch()

  function updateBithPlaceHelper(addedItem) {
    dispatch({ type: actionTypes.UPDATE_BIRTHPLACE_SELECT, payload: { addedItem } })
  }
  return (
    <Grid.Column style={{ borderRight: '1px solid rgba(34,36,38,.15)', borderBottom: '1px solid rgba(34,36,38,.15)' }}>
      {!!fields.IND_Name && (
        <FormLayout
          label={translate('lbl_firstname')}
          visible={noVisibilityFilter || !!fields.IND_Name}
          labelFieldProportions="5:11"
        >
          {!!fields.IND_Name && (
            <FormField
              name="IND_Name"
              autoFocus
              type="text"
              required={isRequired(fields.IND_Name)}
              maxLength={fields.IND_Name ? fields.IND_Name.MaxLen : -1}
              onBlur={onTranslateAltRequest('IND_Name_ALT')}
            />
          )}
          <FormField
            name="IND_Name_ALT"
            type="text"
            placeholder={translate('txt_firstname_alt')}
            required={isRequired(fields.IND_Name_ALT)}
            maxLength={fields.IND_Name_ALT ? fields.IND_Name_ALT.MaxLen : -1}
          />
        </FormLayout>
      )}

      {!!fields.IND_Surname && (
        <FormLayout
          label={translate('lbl_lastname')}
          visible={noVisibilityFilter || !!fields.IND_Surname}
          labelFieldProportions="5:11"
        >
          {!!fields.IND_Surname && (
            <FormField
              name="IND_Surname"
              type="text"
              required={isRequired(fields.IND_Surname)}
              maxLength={fields.IND_Surname ? fields.IND_Surname.MaxLen : -1}
              onBlur={onTranslateAltRequest('IND_Surname_ALT')}
            />
          )}
          <FormField
            name="IND_Surname_ALT"
            type="text"
            placeholder={translate('txt_lastname_alt')}
            required={isRequired(fields.IND_Surname_ALT)}
            maxLength={fields.IND_Surname_ALT ? fields.IND_Surname_ALT.MaxLen : -1}
          />
        </FormLayout>
      )}

      {!!fields.IND_FatherName && (
        <FormLayout
          label={translate('lbl_fathername')}
          visible={noVisibilityFilter || !!fields.IND_FatherName}
          labelFieldProportions="5:11"
        >
          {!!fields.IND_FatherName && (
            <FormField
              name="IND_FatherName"
              type="text"
              required={isRequired(fields.IND_FatherName)}
              maxLength={fields.IND_FatherName ? fields.IND_FatherName.MaxLen : -1}
              onBlur={onTranslateAltRequest('IND_FatherName_ALT')}
            />
          )}
          <FormField
            name="IND_FatherName_ALT"
            placeholder={translate('txt_fathername_alt')}
            type="text"
            required={isRequired(fields.IND_FatherName_ALT)}
            maxLength={fields.IND_FatherName_ALT ? fields.IND_FatherName_ALT.MaxLen : -1}
          />
        </FormLayout>
      )}

      {(!!fields.IND_BirthCountryID || !!fields.IND_DOB) && (
        <FormLayout
          label={translate('lbl_pers_dob')}
          visible={noVisibilityFilter || !!fields.IND_DOB}
          labelFieldProportions="5:11"
          fieldProportions="6:10"
        >
          {!!fields.IND_DOB && <FormField name="IND_DOB" type="date" required={isRequired(fields.IND_DOB)} />}

          {!!fields.IND_BirthCountryID && (
            <FormField
              visible={noVisibilityFilter || !!fields.IND_BirthCountryID}
              name="IND_BirthCountryID"
              type="select"
              search
              required={isRequired(fields.IND_BirthCountryID)}
              options={selects.Citizenship}
            />
          )}
        </FormLayout>
      )}

      {!!fields.IND_BirthPlace && (
        <FormLayout
          label={translate('lbl_birthplace')}
          visible={noVisibilityFilter || !!fields.IND_BirthPlace}
          labelFieldProportions="5:11"
        >
          {!!fields.IND_BirthPlace && (
            <FormField
              type="selectFieldWithAdditions"
              name="IND_BirthPlace"
              required={isRequired(fields.IND_BirthPlace)}
              options={selects.BirthplaceHelper}
              onItemAdd={updateBithPlaceHelper}
              maxLength={fields.IND_BirthPlace && fields.IND_BirthPlace.MaxLen}
              onBlur={(_, value) => {
                onTranslateAltRequest('IND_BirthPlace_ALT')({
                  target: {
                    value,
                  },
                })
              }}
            />
          )}
          <FormField
            type="text"
            name="IND_BirthPlace_ALT"
            placeholder={translate('txt_birthplace_alt')}
            required={isRequired(fields.IND_BirthPlace_ALT)}
            maxLength={fields.IND_BirthPlace_ALT ? fields.IND_BirthPlace_ALT.MaxLen : -1}
          />
        </FormLayout>
      )}
    </Grid.Column>
  )
}

export default PersonalInformation
